import PasswordInvisibilityController from './sessions/password_visibility_controller'

export default class extends PasswordInvisibilityController {
}
